<template>
	<div class="main bgwhite" v-title data-title="零部件企业" style="padding-bottom: 50px;">
		<iHeader ref="loginIndex" :message="msg"></iHeader>
		<div class="barprebox max1350 mt25">
			<h2>{{newT}}</h2>
			<div class="auth"><span>发布时间：{{Ntime}}</span></div>
			<div class="cont" v-html="newcont">
			</div>
		</div>
		<v-footer></v-footer>
	</div>
</template>

<script>
	import Cookies from 'js-cookie'
	// 公共头部组件
	import iHeader from "@/components/indexheader"
	// footer
	import vFooter from "@/components/Footer"
	import "@/assets/cont-01.css";
	import Vue from 'vue';
	import axios from 'axios';
	Vue.prototype.$axios = axios;
	export default {
		components: {
			iHeader,
			vFooter,
		},
		data() {
			return {
				msg: "company",
				newid: '',
				newcont:'',
				newT:'',
				Ntime:''
			}
		},
		created() {
			this.newid = this.$route.query.newid
			this.handnewslist()
		},
		methods: {
			handnewslist() {
				this.$postcn('partshome/newinfo', {
					id:this.newid
				}, this).then((res) => {
					if (res.data.code == -4004) {
						this.$refs.loginIndex.handLogin(window.location.href)
					} else {
						this.newcont=res.data.new_con
						this.newT=res.data.new_title
						this.Ntime=res.data.update_time
					}
				})
			},
			removeTAG(str){
			        return str.replace(/<[^>]+>/g, "");
			    }
		}
	}
</script>

<style scoped="scoped">
	.auth {
		vertical-align: middle;
		text-align: center;
		height: 30px;
		padding-left: 10px;
		margin-top: 12px;
	}
 
	.mr20 {
		margin-right: 20px;
	}

	.auth .date {
		font-size: 14px;
		color: #999999;
		line-height: 25px;
	}

	.cont {
		text-align: left;
		text-indent: 2em;
		line-height: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/company/newcont.vue